import { createServerClient } from "@supabase/ssr";
import { NextResponse, type NextRequest } from "next/server";

export async function updateSession(request: NextRequest) {
  let supabaseResponse = NextResponse.next({
    request,
  });

  const supabase = createServerClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      cookies: {
        getAll() {
          return request.cookies.getAll();
        },
        setAll(cookiesToSet) {
          cookiesToSet.forEach(({ name, value }) =>
            request.cookies.set(name, value)
          );
          supabaseResponse = NextResponse.next({
            request,
          });
          cookiesToSet.forEach(({ name, value, options }) =>
            supabaseResponse.cookies.set(name, value, options)
          );
        },
      },
    }
  );

  const authQuery = await supabase.auth.getClaims();
  const auth = authQuery?.data?.claims;

  if (request.nextUrl.pathname.startsWith("/admin")) {
    if (request.nextUrl.pathname === "/admin/login") {
      if (auth) {
        const url = request.nextUrl.clone();
        url.pathname = "/admin/main";
        return NextResponse.redirect(url);
      }

      return supabaseResponse;
    }

    if (!auth) {
      const url = request.nextUrl.clone();
      url.pathname = "/admin/login";
      return NextResponse.redirect(url);
    }

    const userQuery = await supabase
      .from("user")
      .select("*")
      .eq("id", auth?.sub)
      .single();
    if (userQuery.error) throw new Error(userQuery.error.message);

    if (userQuery.data?.role !== "admin") {
      // authLogout() 대신 middleware에서 직접 signOut 호출
      await supabase.auth.signOut();
      const url = request.nextUrl.clone();
      url.pathname = "/ahth/login";
      return NextResponse.redirect(url);
    }
  }

  return supabaseResponse;
}
